import React from "react";
import { Outlet, useParams } from "react-router-dom";
import ChatList from "./ChatList";
import { MessageSquare } from "lucide-react";

/**
 * ChatsShell — two-pane layout on desktop (list left, thread right).
 * On mobile only one pane is visible at a time based on whether we're on
 * /chats (list) or /chats/:peer_id (thread).
 */
export default function ChatsShell() {
  const { peer_id } = useParams();
  const hasActive = Boolean(peer_id);

  return (
    <div className="h-[calc(100vh-120px)] lg:h-screen flex bg-background">
      {/* Left list — always visible on desktop; only on mobile when no thread is open */}
      <aside
        className={`${hasActive ? "hidden lg:flex" : "flex"} flex-col w-full lg:w-[340px] xl:w-[380px] lg:shrink-0 border-r border-border min-h-0`}
        data-testid="chats-list-pane"
      >
        <ChatList />
      </aside>

      {/* Right pane — thread on desktop always visible; on mobile shown when a thread is open */}
      <section
        className={`${hasActive ? "flex" : "hidden lg:flex"} flex-1 min-w-0 flex-col min-h-0`}
        data-testid="chats-thread-pane"
      >
        {hasActive ? (
          <Outlet />
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center text-center px-8" data-testid="chats-empty-thread">
            <div className="w-16 h-16 rounded-full border border-border flex items-center justify-center mb-4">
              <MessageSquare className="w-7 h-7 text-muted-foreground" />
            </div>
            <div className="font-serif text-2xl mb-1">Your messages</div>
            <div className="text-sm text-muted-foreground max-w-sm">
              Select a chat on the left to keep the conversation going, or share a debate to start a new one.
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
